import { Consume } from "../../../Context/Consumer";
import React, { Component } from "react";
import {
  PlayerListContext,
  TransContext,
  TeamDataContext,
  CompositionContext,
} from "../../../Context";
import {
  getTrans,
  customTracking,
  setDropDownHeight,
  getPageName,
} from "../../../common";
import { Scrollbars } from "react-custom-scrollbars";
import config from "../../../common/config";
import OutsideNotifier from "../../../components/OutsideNotifier";
import { slice, debounce } from "lodash";

class WebCountryFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openCountryFilter: false,
      clearSearch: false,
    };
  }

  onOpenCountryFilter = (value) => {
    if (value != undefined) {
      this.setState({
        openCountryFilter: false,
      });
    } else {
      this.setState({
        openCountryFilter: !this.state.openCountryFilter,
      });
    }
  };

  onCountrySelected = (e, countryObj) => {
    let self = this;
    let { state, props, onOpenCountryFilter } = self;
    let { PlayerListData, TeamData } = props;
    e.stopPropagation();
    let countryArr = PlayerListData.playerListFilters.teamIds;
    let countryNameObj = PlayerListData.playerListFilters.teamNamesObj;
    let countryId = countryObj.TeamId;
    if (countryArr.indexOf(countryId) > -1) {
      let index = PlayerListData.playerListFilters.teamIds.indexOf(countryId);
      countryArr.splice(index, 1);
      countryNameObj.splice(index, 1);
    } else {
      countryArr.splice(0, 1);
      countryNameObj.splice(0, 1);
      countryArr.push(countryObj.TeamId);
      countryNameObj.push(countryObj);
      onOpenCountryFilter(false);
    }

    let budget = TeamData.data.budget;
    PlayerListData.setPlayerFilters(PlayerListData.playerListFilters, budget);
  };

  resetClubs = (e) => {
    e.stopPropagation();
    this.props.CompositionData.resetSearchString("");
    let budget = this.props.TeamData.data.budget;
    this.props.PlayerListData.playerListFilters.teamIds = [];
    this.props.PlayerListData.playerListFilters.teamNamesObj = [];
    this.props.PlayerListData.setPlayerFilters(
      this.props.PlayerListData.playerListFilters,
      budget
    );
    this.setState({
      openCountryFilter: false,
    });
  };

  handleChange = (event) => {
    let searchVal = event.target.value;
    this.props.CompositionDat.setSearchString(searchVal);
    debounce(() => {
      this.props.CompositionData.setTeamFilter();
    }, 500)();
  };

  clearSearch = (e) => {
    e.stopPropagation();
    this.setState({
      clearSearch: true,
    });
    this.props.CompositionData.resetSearchString("");
  };

  render() {
    let self = this;
    let { props, state, onOpenCountryFilter, onCountrySelected } = self;
    let { CompositionData, PlayerListData, TransData } = props;
    let TeamListContextData =
      CompositionData && CompositionData.TeamListContextData;
    let { openCountryFilter } = state;
    let countryArr = PlayerListData.playerListFilters.teamIds;
    let searchString = CompositionData && CompositionData.searchString;
    let countryNameObj = PlayerListData.playerListFilters.teamNamesObj;
    const clubsToDisplay = slice(countryNameObj, 0, 3);
    const diff = countryArr.length - 3;
    const countLeft = diff > 0 ? "+" + diff : "";
    let trans = TransData.data;
    let handler = {
      handler: () => {
        onOpenCountryFilter(false);
      },
    };
    if (searchString == "" && this.state.clearSearch && !countryArr.length) {
      handler = { handler: () => {} };
    } else {
      handler = {
        handler: () => {
          onOpenCountryFilter(false);
        },
      };
    }
    return (
      <div className="si-form__control">
        <OutsideNotifier {...handler}>
          <div className="si-lbl">
            <span>{getTrans(trans, "by_team", "By Team")}</span>
          </div>
          <div
            className={"si-drpDwn " + (openCountryFilter ? "si-active" : "")}
            onClick={() => {
              onOpenCountryFilter();
            }}
          >
            <div
              className={
                "si-drpDwn__value " +
                (countryNameObj && countryNameObj.length ? "si-picked" : "")
              }
            >
              <span>
                {countryNameObj && countryNameObj.length
                  ? countryNameObj[0].WebName
                  : getTrans(trans, "select_club", "Select Club")}
              </span>
              <select
                onChange={(e) => {
                  const countryObj = TeamListContextData?.filter(
                    (a) => a.WebName === e.target.value
                  );
                  onCountrySelected(e, ...countryObj);
                }}
              >
                {TeamListContextData &&
                  TeamListContextData.map((countryObj) => {
                    const isSelected =
                      countryArr.indexOf(countryObj.TeamId) > -1;
                    return (
                      <option
                        key={countryObj.TeamId}
                        className={isSelected ? "si-active" : ""}
                        // onClick={(e) => {
                        //   onCountrySelected(e, countryObj);
                        // }}
                      >
                        {countryObj.WebName}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="si-drpDwn__list">
              <Scrollbars className="si-scroll_js">
                <ul>
                  {TeamListContextData &&
                    TeamListContextData.map((countryObj) => {
                      const isSelected =
                        countryArr.indexOf(countryObj.TeamId) > -1;
                      return (
                        <li
                          className={isSelected ? "si-active" : ""}
                          key={countryObj.TeamId}
                          onClick={(e) => {
                            onCountrySelected(e, countryObj);
                          }}
                        >
                          <span>{countryObj.WebName}</span>
                        </li>
                      );
                    })}
                </ul>
              </Scrollbars>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    );
  }
}

export class ClubSearchInput extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.nameInputClub.focus();
  }

  render() {
    return (
      <input
        type="search"
        ref={(input) => {
          this.nameInputClub = input;
        }}
        placeholder={getTrans(this.props.trans, "search", "Search")}
        value={this.props.searchString}
        onChange={(e) => this.props.handleChange(e)}
      />
    );
  }
}

export default Consume(WebCountryFilter, [
  PlayerListContext,
  TransContext,
  TeamDataContext,
  CompositionContext,
]);
